import { render, staticRenderFns } from "./PenilaianPelaksanaanPelakuUsaha.vue?vue&type=template&id=20c7706e&"
import script from "./PenilaianPelaksanaanPelakuUsaha.vue?vue&type=script&lang=js&"
export * from "./PenilaianPelaksanaanPelakuUsaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports